export default __webpack_public_path__ + "static/bretagne_self-modern_text_web-7936ea7c0e62cd40920b47ea3c9e71f8.woff2";